import {useInjection} from "inversify-react";
import {useCallback, useEffect, useState} from "react";
import ApiService from "../../services/apiService";
import {BasketApi, BasketDto} from "../../api";
import {useParams} from "react-router-dom";
import BasketProductsList from "./basketProductsList";

export default function BasketProductsListContainer() {
    const apiService = useInjection(ApiService);
    const [basket, setBasket] = useState<BasketDto | null>();
    const {basketId} = useParams();

    const refreshBasketsList = useCallback(async () => {
        try {
            const basket = await apiService.getApi(BasketApi)
                .apiBasketGetBasketByIdIdGet(basketId!);
            setBasket(basket.data);
        } catch (e: any) {
            console.log(e.response.data);
        }
    }, [apiService]);

    const onDeleteClicked = async (id: string, count: number) => {
        try {
            await apiService.getApi(BasketApi)
                .apiBasketRemoveFromBasketDelete({
                    basketItemId: id,
                    count: count
                });
            await refreshBasketsList();
        } catch (e: any) {
            console.log(e);
        }
    }

    useEffect(() => {
        refreshBasketsList();
    }, [refreshBasketsList]);

    return <>
        <h1>Produkty w koszyku</h1>
        <BasketProductsList
            customDeleteClicked={onDeleteClicked}
            data={basket?.items || []}
        />
    </>
}
